<template>
  <b-navbar-nav class="ml-auto">
    <div v-show="troubleProductWarn" class="message-box message-warn">　管理品あり　</div>
    <div v-show="isWarnDeposit" class="message-box message-warn-right">　デポジット不足　</div>
    <div v-show="isWarnShippingStop" class="message-box message-warn-right">　デポジット不足のため発送保留荷物あり　</div>
  </b-navbar-nav>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';

export default {
  mixins: [BaseComponent],
  props: {
    isWarnDeposit: {
      default: false,
    },
    isWarnShippingStop: {
      default: false,
    },
    troubleProductWarn: {
      default: false,
    },
  },
  methods: {
  },
};
</script>

<style scoped>
.message-box {
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  text-align: center;
  font-size: small;
  display: inline-block;
  /* width: 7rem */
}
.message-warn {
  background-color: red;
  color: white;
}
.message-warn-right {
  background-color: red;
  color: white;
  margin-left: 1rem;
}
</style>
